import React, { useEffect, useState, useMemo } from 'react';
import { BreadCrumbs, DataGrid, EditButton, formatters } from '../../../../Core/Controls';
import { getVechicleIDByRegNO } from '../../../../Core/Services/InternalUser/ServiceAgent/breakdownService';
import AddBreaddownModal from '../../../InternalUser/Maintenance/BreakDown/AddBreakdown'; //"./AddBreakdown";
import WorkIcon from '@material-ui/icons/Work';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import { Link } from 'react-router-dom';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
// import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import Grid from '@material-ui/core/Grid';
import BuildIcon from '@material-ui/icons/Build';
import { AppStorage } from '../../../../Core/Basic/storage-service';

const baseCrumbs = [{ name: 'Home', path: '/' }, { name: 'Maintenance' }, { name: 'Breakdowns', active: true }];

const baseColumns = [
    { key: 'action', name: 'Action', width: 120, addFileUploaderIcon: true },
    {
        key: 'defectDate',
        name: 'Date ',
        formatter: formatters.Date_DDMMYYYY,
        width: 110
    },
    { key: 'defectNumberGenerated', name: 'Defect No', width: 100 },
    { key: 'defectDescription', name: 'Defect Details' },
    { key: 'defectContactName', name: 'Reported By', width: 150 },
    { key: 'defectJobStatusDescription', name: 'Status', width: 200 },
    { key: 'defectType', name: 'DefectType', width: 150 }
];

const CustomerBreakDownDashboard = (props) => {
    let checkhaveAccess = AppStorage.getAllowAcces();

    const [state, setState] = useState({
        breakdownList: [],
        loader: true,
        modalToggle: false,
        breakID: null,
        rowVehicleID: null,
        filterVal: '',
        show: false,
        filterVehicleID: null
    });

    const handleBreakDown = (params, VehicleID, modalName) => {
        setState((st) => ({
            ...st,
            modalToggle: true,
            breakID: params,
            rowVehicleID: VehicleID,
            modalName: modalName
        }));
    };

    const closeModal = (res) => {
        setState((st) => ({
            ...st,
            filterVal: '',
            modalToggle: false,
            show: false,
            breakID: null,
            rowVehicleID: null
        }));
        res && pullBreakDownAndUpdateState();
    };

    useEffect(async () => {
        if (!props.VehicleID) {
            if (state.filterVal.length > 4) {
                let resBrekDown = await getVechicleIDByRegNO(state.filterVal);
                setState((st) => {
                    let newSt = { ...st };
                    if (resBrekDown.data?.list) {
                        newSt.show = resBrekDown.success;
                        newSt.filterVehicleID = resBrekDown.data?.list[0].vehicleID;
                        newSt.isReload = new Date();
                    } else {
                        newSt.show = false;
                    }
                    return newSt;
                });
            } else {
                setState((st) => ({ ...st, show: false }));
            }

            // pullBreakDownAndUpdateState();
        }
    }, [state.filterVal, props.match]);

    useEffect(() => {
        pullBreakDownAndUpdateState();
    }, []);

    const pullBreakDownAndUpdateState = async () => {
        let defecttypecode = '';
        if (props.VehicleID) {
            defecttypecode = '';
        }
        if (props?.match?.params?.all == 'typebo') {
            defecttypecode = 'bo';
        }
        if (props?.match?.params?.all == 'typebr') {
            defecttypecode = 'br';
        }
        if (props?.match?.params?.all == ':all') {
            defecttypecode = '';
        }
        setState((st) => ({ ...st, defecttypecode: defecttypecode }));
    };

    let urlForcondition = `VehicleBreakdowns/?${props.VehicleID ? `VehicleID=${props.VehicleID}` : ''}defecttypecode=${state.defecttypecode}`;

    const handleEditClick = (val) => {
        props.history.push({
            pathname: `/controller/jobTabScreen/${val?.defectJobID}/${val?.defectVehicleID}`,
            state: 'breakdown'
        });
    };

    const handleEditBreakdown = (val) => {
        props.history.push({
            pathname: `/maintenance/breakdowns/Edit/${val?.defectID}/${val?.defectVehicleID}`,
            state: 'Edit'
        });
    };

    const dataFormatter = (data, row) => {
        return (
            <Grid item>
                <CustomIconButton
                    icon={BuildIcon}
                    color="secondary"
                    className="modal-btn-update btn_space"
                    toolTipTitle="Edit Breakdown"
                    // onClick={() => handleBreakDown(row.defectID, row.defectVehicleID, 'Edit')}
                    onClick={() => handleEditBreakdown(row)}
                />
                {/* <EditButton toolTipTitle="Edit Breakdown" onClick={() => handleBreakDown(row.defectID, row.defectVehicleID, 'Edit')} /> */}
                {checkhaveAccess?.CanViewJobs && (
                    <CustomIconButton
                        icon={WorkIcon}
                        color="secondary"
                        className="modal-btn-update btn_space"
                        toolTipTitle="Job Details"
                        onClick={() => handleEditClick(row)}
                    />
                )}
            </Grid>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.key === 'action');
        if (actionCol) {
            actionCol.formatter = dataFormatter;
        }
        if (!props.VehicleID) {
            tempCols.splice(1, 0, { key: 'defectRegNumber', name: 'Reg Number', width: 110 });
        }

        return tempCols;
    }, []);

    const crumbs = useMemo(() => {
        const tempCols = [...baseCrumbs];
        let actionCol = tempCols.find((element) => element.name === 'Breakdowns');
        if (actionCol) {
            actionCol.onClick = closeModal;
        }

        return tempCols;
    }, []);
    const gridBtnTitle = !state.show && !props.VehicleID ? '' : 'Add Breakdown';

    const inputChange = (e) => {
        const value = e.target.value;
        setState((st) => ({
            ...st,
            filterVal: value
        }));
    };

    return (
        <div className={!props.frompage ? `screen` : ''}>
            {props.frompage !== 'Vehicles' ? (
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', alignContent: 'center', position: 'relative', top: 0 }}>
                    <div style={{ width: 'auto' }}>
                        <BreadCrumbs crumbs={crumbs} className="edit-service-agent-btn" />
                    </div>
                    &nbsp;&nbsp;
                    {!state.breakID || !state.rowVehicleID ? (
                        <div style={{ width: 'auto' }}>
                            <input type="text" onChange={inputChange} placeholder="Enter Reg Number" value={state.filterVal} style={{ padding: 5 }} />
                        </div>
                    ) : null}
                </div>
            ) : null}
            {state.modalToggle ? (
                <>
                    <br />
                    <AddBreaddownModal
                        VehicleID={props.VehicleID || state.rowVehicleID || state.filterVehicleID}
                        onClose={() => closeModal(true)}
                        breakDownID={state.breakID}
                        isAddJobBtnShow={true}
                        modalName={state.modalName}
                    />
                </>
            ) : (
                <GijgoGrid
                    columns={columns}
                    getUrl={urlForcondition}
                    dataConverter={(res) => ({
                        records: res.data.list,
                        total: res.data.total
                    })}
                    isReload={state.isReload}
                    btnTitle={gridBtnTitle}
                    onBtnClick={() => handleBreakDown(null, state.filterVehicleID, 'Add')}
                    idFieldName="defectID"
                    fileUploaderConfigName="BreakdownScreen"
                />
            )}
        </div>
    );
};

export default CustomerBreakDownDashboard;
